var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "filters-container" },
    _vm._l(_setup.parsedFilters, function (filter) {
      return _c(
        "v-chip",
        {
          key: filter.field,
          staticClass: "ma-2",
          attrs: { "x-small": "", close: "", label: "" },
          on: {
            "click:close": function ($event) {
              return _setup.removeFilter(filter)
            },
          },
        },
        [
          _vm._v(" " + _vm._s(filter.field) + ": "),
          _c("b", [_vm._v(" " + _vm._s(filter.value))]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }